import { Component, Input, ViewChild } from '@angular/core';
import { CoreSearchSettings } from '../services/search.service';
import { AppMessageService } from '../../../services/app-message/app-message.service';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-search-settings',
  standalone: false,

  templateUrl: './search-settings.component.html',
  styleUrl: './search-settings.component.scss'
})
export class SearchSettingsComponent {

  @ViewChild('op') configPanel: OverlayPanel;

  @Input({ required: true }) settings!: CoreSearchSettings;
  fixLimit: number = 18;
  outoFocus: boolean = true;

  isMoreSettingsOpen: boolean = false;
  private lastEvent: MouseEvent;

  constructor(private readonly mesage: AppMessageService) {}

  configChanged() {
    if (this.settings.filters.limit > 99 || this.settings.filters.limit < 5) {
      this.mesage.errorToast('Geçersiz Limit', 'Öge Arama Limiti 5 ila 99 arasında olabilir!');
      return;
    }
    localStorage.setItem('search_settings', JSON.stringify(this.settings));
  }

  hide() {
    this.configPanel.hide();
  }

  toggle(event: MouseEvent) {
    this.lastEvent = event;
    this.configPanel.toggle(event);
  }

  openOtherSettings() {
    this.isMoreSettingsOpen = !this.isMoreSettingsOpen;
    this.configPanel.hide();
    setTimeout( () => {
      this.configPanel.show(this.lastEvent);
    }, 200);
  }

}
